import { setColorTheme } from '@facephi/ui-react';
import {
  FacialAuthenticationStatus,
  StatusOperations,
  StatusTypeList,
} from '../states';

export const setStatusStyles = (status?: string, negative?: boolean) => {
  switch (status) {
    case StatusOperations.CHECK_PLATFORM:
      return `
      background-color: ${setColorTheme('grey500')};

      *,
      p {
        color: ${setColorTheme('white')};
      }
      `;
    case StatusTypeList.NONE:
    case StatusTypeList.IN_PROGRESS:
    case StatusTypeList.STARTED:
      return `
          background-color: ${
            negative ? setColorTheme('grey100') : setColorTheme('white')
          };
      `;
    case FacialAuthenticationStatus.positive.toUpperCase():
    case StatusTypeList.SAVED:
    case StatusTypeList.SUCCEEDED:
    case StatusTypeList.VALIDATE:
    case StatusTypeList.CORRESPONDED:
      return `
          background-color: ${setColorTheme('success400')};
  
          *,
          p,a {
            color: ${setColorTheme('white')};
          }
        `;
    case FacialAuthenticationStatus.uncertain.toUpperCase():
    case StatusOperations.EXPIRED:
    case StatusOperations.CONNECTION_ERROR:
    case StatusTypeList.PENDENT:
      return `
        background-color: ${setColorTheme('warning400')};
  
        *,
        p,a {
          color: ${setColorTheme('white')};
        }
      `;
    case FacialAuthenticationStatus.negative.toUpperCase():
    case StatusOperations.CANCELLED:
    case StatusTypeList.DENIED:
    case StatusTypeList.NOT_CORRESPONDED:
      return `
        background-color: ${setColorTheme('error400')};
  
        *,
        p,a {
          color: ${setColorTheme('white')};
        }
      `;
  }
};
